import lsApi from "../api/lsApi";
import { useAppSelector } from '../redux/hooks';
import { IReceivedPayments } from '../models/payments';

export function usePagosRecibidos() {
  const userData = useAppSelector((state) => state.auth.userData);
  const { nombre, usuario, nombre_Empresa } = userData!;
  const propietario = nombre;
  const casa = usuario.slice(2);
  const newDate = new Date();
  const month = (newDate.getMonth() + 1).toString().padStart(2, '0');
  const errFecha = `${newDate.getFullYear()}-${month}-00`;

  const getPagosRecibidos = async () => {
    try {
      const { status, data } = await lsApi.get<IReceivedPayments[]>(`/api/ControlAcceso/PagosDelMes?INANIO=${newDate.getFullYear()}&VACASA=${casa}`);
      if (status === 200) {
        return data;
      } else {
        return [
          {
            id: status.toString(),
            num_Boleta: `status ${status}`,
            fecha: errFecha,
            valor: status
          }
        ];
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  const downloadRecibo = async (uuid?: string, empresa?: number) => {
    try {
      if(!uuid) {
        alert('No se encuentra el recibo para descargar');
       return;
      }
      let dev = "";
      if(empresa === 330){
        dev ="-dev";
      }
      const response = await fetch(`https://print${dev}.totaldoc.io/pdf?uuid=${uuid}`, {
        method: 'GET'
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Recibo_${uuid}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }
    catch (error) {
      console.error('Error downloading recibo:', error);
      alert('Error al descargar el recibo. Por favor, inténtelo de nuevo más tarde.');
    }
  }

  return {
    getPagosRecibidos,
    propietario,
    casa,
    condominio: nombre_Empresa,
    downloadRecibo
  };
}